module.exports = __webpack_public_path__ + "static/img/IMG_20160308_145513.0e80ee87.jpg";